import { useEffect } from "react";
import WOW from "wowjs";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./Pages/Home";
import BusinessGrowLearnMore from "./Pages/BusinessGrowLearnMore";
import CarouselLearnMore from "./Pages/CarouselLearnMore";
import ErpServices from "./Pages/ErpServices";
import DatabaseAdminServices from "./Pages/DatabaseAdminServices";
import CustomisedApplicationDev from "./Pages/CustomisedApplicationDev";
import SuccessStoriesReadMore from "./Pages/SuccessStoriesReadMore";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Services from "./Pages/Services";
import Team from "./Pages/Team";
import Blog from "./Pages/Blog";
import Startcounter from "./Pages/Startcounter";
import Startportfolio from "./Pages/Startportfolio";
import Verticals from "./Pages/Verticals";
import ContactUs from "./Pages/ContactUs";
import ThankYou from "./Pages/Thankyou";
import OurVision from "./Pages/OurVision";
import Plans from "./Pages/Plans";
import Manufacture from "./Pages/Manufacture";
import Retail from "./Pages/Retail";
import School from "./Pages/School";
import Loader from "./Pages/Loader";
import Navbar from "./Pages/Navbar";
import Contact from "./Pages/Contact";
import ProtectedRoute from "./ProtectedRoute";
import { ObserverProvider } from "./Contexts/ObserverContext";
import "./styles/style.css";
import "./App.css";

function App() {

  useEffect(() => {
    if (navigator.userAgent === "ReactSnap") return;

    if (typeof window !== "undefined") {
      const wow = new WOW.WOW({ live: false });
      wow.init();
    }
  }, []);

  useEffect(() => {
    if (navigator.userAgent === "ReactSnap") return;

    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/69673d38895de4198b90185d/1jetke9k5";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <ObserverProvider>
      <Loader />
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<CarouselLearnMore />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/manufacture" element={<Manufacture />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/retail" element={<Retail />} />
          <Route path="/school" element={<School />} />
          <Route path="/our-vision" element={<OurVision />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          <Route path="/accomplishments" element={<Startcounter />} />
          <Route path="/projects" element={<Startportfolio />} />
          <Route path="/alliances" element={<Verticals />} />
          <Route path="/thank-you" element={<ProtectedRoute Component={ThankYou} />} />
          <Route path="/our-services" element={<BusinessGrowLearnMore />} />
          <Route path="/erp-services" element={<ErpServices />} />
          <Route path="/database-services" element={<DatabaseAdminServices />} />
          <Route path="/custom-development" element={<CustomisedApplicationDev />} />
          <Route path="/read-more/:type" element={<SuccessStoriesReadMore />} />
        </Routes>
        <Contact />
      </BrowserRouter>
    </ObserverProvider>
  );
}

export default App;
